import { render, staticRenderFns } from "./ReferenceNumberForm.vue?vue&type=template&id=a1d4c45e&scoped=true&"
import script from "./ReferenceNumberForm.vue?vue&type=script&lang=js&"
export * from "./ReferenceNumberForm.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceNumberForm.vue?vue&type=style&index=0&id=a1d4c45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d4c45e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
